module.exports = __webpack_public_path__ + "pl.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/pl.svg
// module id = 1014
// module chunks = 0